const QuestionDirection = {
    NEGATIVE_TO_POSITIVE: 'negativeToPositive',
    POSITIVE_TO_NEGATIVE: 'positiveToNegative',
    RANDOM: 'random'
};

Object.freeze(QuestionDirection);

export default QuestionDirection;